<template>
  <div class="w-full h-full flex flex-col bg-white rounded-small shadow-theme overflow-hidden">
    <process-tab :active="active" :current="current" @tapStep="tapStepHandle"/>
    <div class="flex-1 overflow-hidden">
      <dimension-setting v-if="current === 1" />
      <topic-bind v-else-if="current === 2"/>
      <standard-score-weight-setting v-else-if="current === 3"/>
      <evaluation-report-setting v-else-if="current === 4"/>
    </div>
  </div>
</template>

<script>
import ProcessTab from './ProcessTab';
import TopicBind from './TopicBind';
import DimensionSetting from './DimensionSetting';
import StandardScoreWeightSetting from './StandardScoreWeightSetting';
import EvaluationReportSetting from './EvaluationReportSetting';

export default {
  name: 'ProcessContent',
  components: {
    ProcessTab,
    DimensionSetting,
    TopicBind,
    StandardScoreWeightSetting,
    EvaluationReportSetting
  },
  inject: {
    topSource: {
      default: () => ({})
    }
  },
  computed: {
    active() {
      return this.topSource.active ?? null;
    },
    current() {
      return this.topSource.currentView ?? 1;
    }
  },
  methods: {
    tapStepHandle(step) {
      const isFn = typeof this.topSource.onStepBefore === 'function';
      if (isFn) {
        const isNext = this.topSource.onStepBefore();
        if (Object.prototype.toString.call(isNext) === '[object Promise]') {
          isNext.then(() => {
            this.topSource.currentView = step;
            this.topSource.onStepBefore = null;
          }).catch(() => {});
        } else if (isNext) {
          this.topSource.currentView = step;
          this.topSource.onStepBefore = null;
        }
      } else {
        this.topSource.currentView = step;
        this.topSource.onStepBefore = null;
      }
    }
  }
}
</script>